import { BASE_URL } from "../config";

export async function submitLead({ name, email, phone, businessType, message, source, packageName }) {
  const fullMessage = [
    packageName ? `Package: ${packageName}` : null,
    phone ? `Phone: ${phone}` : null,
    businessType ? `Business Type: ${businessType}` : null,
    source ? `Source: ${source}` : null,
    message ? `\n${message}` : null,
  ].filter(Boolean).join("\n");

  const safeMessage = (fullMessage && fullMessage.trim().length >= 10)
    ? fullMessage.trim()
    : `Lead enquiry from ${name || "visitor"} (${email || "no-email"})`;

  const response = await fetch(`${BASE_URL}/contact_ai4bazaar`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email, message: safeMessage }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data.error || "Failed to submit");
  return data;
}

export function getCampaignSource() {
  const params = new URLSearchParams(window.location.search);
  return params.get("utm_source") || params.get("source") || "website";
}
